export enum EgressOptionEnum {
  All = 0,
  API,
  ServiceBus,
  DataLake,
  Kusto,
  GraphQLAPI,
  Snapshot = 7,
}
